import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollerService {

  containerEl!: Element;
  // TODO: make this a subject so we can recalculate scrollTo if height changes mid-scroll
  topOffset: number = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) { }

  scrollTo(selector: string) {
    const targetEl = this.containerEl.querySelector(selector);

    if (targetEl && this.containerEl) {
      const containerScrollTop = this.containerEl.scrollTop;
      const containerBox = this.containerEl.getBoundingClientRect();
      const targetBox = targetEl.getBoundingClientRect();

      const topOfContainer = Math.round(containerBox.top) + this.topOffset;

      const diff = (Math.round(targetBox.top) - topOfContainer) + containerScrollTop;

      this.containerEl.scrollTo({
        top: diff,
        behavior: 'smooth'
      });
    }
  }

  scrollToTop() {
    const scrollThis = this.containerEl ?? this.document.defaultView;

    scrollThis.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

}
